module.exports = __webpack_public_path__ + "static/img/member.b8e2c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/member.png
// module id = liCf
// module chunks = 1